/* eslint-disable key-spacing */
export const add = {
  username            : {
    required          : { rule: true, message : "Vous devez fournir un nom d'utilisateur" },
    maxlength         : { rule: 255, message : '' },
    minlength         : { rule: 6, message : "Le nom d'utilisateur doit être composé d'au moins 8 caractêres" },
    usernameUnique    : { rule: true, message : "Le nom d'utilisateur est déjà pris", initial: 'off' },
    validateUsername  : { rule: true, message : "Le nom d'utilisateur ne doit pas contenir d'espaces ou de caractères spéciaux", initial: 'off' }
  },
  email               : {
    required          : { rule: true, message : 'Vous devez fournir une adresse email' },
    validateEmail     : { rule: true, message : "L'adresse email fournie n'est pas valide", initial: 'off' },
    emailUnique       : { rule: true, message : "L'adresse email est déjà utilisée", initial: 'off' }
  },
  password            : {
    required          : { rule: true, message: 'Vous devez fournir un mot de passe' },
    minlength         : { rule: 8, message : 'Le mot de passe doit contenir au moins 8 caractères' }
  },
  passwordConfirmation: {
    required          : { rule: true, message: 'Vous devez confirmer le mot de passe' },
    passwordMatch     : { rule: true, message: 'Les mots de passe ne correspondent pas', initial: 'off' }
  },
  phone               : {
    required          : { rule: true, message : 'Vous devez fournir un numéro de téléphone' },
    validatePhone     : { rule: true, message : 'Le numéro de téléphone doit être composé de 10 chiffres' }
  },
  firstname           : {
    required          : { rule: true, message: 'Vous devez fournir un prénom' }
  },
  lastname            : {
    required          : { rule: true, message: 'Vous devez fournir un nom de famille' }
  }
}

export const edit = {
  username            : {
    required          : { rule: true, message : "Vous devez fournir un nom d'utilisateur" },
    maxlength         : { rule: 255, message : '' },
    minlength         : { rule: 6, message : "Le nom d'utilisateur doit être composé d'au moins 8 caractêres" },
    validateUsername  : { rule: true, message : "Le nom d'utilisateur ne doit pas contenir d'espaces ou de caractères spéciaux", initial: 'off' }
  },
  email               : {
    required          : { rule: true, message : 'Vous devez fournir une adresse email' },
    validateEmail     : { rule: true, message : "L'adresse email fournie n'est pas valide", initial: 'off' }
  },
  password            : {
    minlength         : { rule: 8, message : 'Le mot de passe doit contenir au moins 8 caractères', initial: 'off' }
  },
  passwordConfirmation: {
    passwordMatch     : { rule: true, message: 'Les mots de passe ne correspondent pas', initial: 'off' }
  },
  phone               : {
    required          : { rule: true, message : 'Vous devez fournir un numéro de téléphone' },
    validatePhone     : { rule: true, message : 'Le numéro de téléphone doit être composé de 10 chiffres' }
  },
  firstname           : {
    required          : { rule: true, message: 'Vous devez fournir un prénom' }
  },
  lastname            : {
    required          : { rule: true, message: 'Vous devez fournir un nom de famille' }
  }
}



// WEBPACK FOOTER //
// ./src/validations/user.js